import React, { useState, useEffect, useCallback } from "react";
import AsyncSelect from "react-select3/async";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import orderBy from "lodash/orderBy";

import { customToast as toast } from "../../utils";
import * as customerActions from "../../actions/customerActions";

const AlternativeNamesSelect = ({
  customers,
  actions,
  label = "Alternative Names",
  placeholder = "Select an Alternative Name",
  isMulti = true,
  name,
  values = [],
  disabled = false,
  setValues = (x) => x,
  getValues = (x) => x,
  onChange
}) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!customers.length) {
      setLoading(true);
      actions.loadCustomers();
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const alternative_names =
    customers?.map((customer) => customer?.alternative_names || []).flat() ||
    [];

  const options = orderBy(
    alternative_names.map((a_n) => ({ label: a_n, value: a_n })),
    [(altName) => altName.label.toLowerCase()]
  );

  const loadingOptions = useCallback(
    async (inputValue = "") =>
      new Promise((resolve) => {
        try {
          setLoading(true);
          if (options && Array.isArray(options) && options.length > 0) {
            const arrayFiltered = options.filter((i) =>
              i.label.toLowerCase().includes(inputValue.toLowerCase())
            );
            resolve(arrayFiltered);
          }
          setLoading(false);
        } catch (err) {
          toast.error();
        } finally {
          setLoading(false);
        }
      }),
    [options]
  );

  const handleChange = (value) => {
    onChange(name, setValues(value));
  };

  return (
    <React.Fragment>
      {label ? (
        <label
          className={`control-label ${!label ? "hidden" : ""}`}
          htmlFor="customer-select"
          style={{ textTransform: "uppercase" }}
        >
          {label}
        </label>
      ) : null}
      <AsyncSelect
        id="alternative-names-select"
        name={name}
        className="react-select-container"
        classNamePrefix="react-select-container"
        placeholder={placeholder}
        disabled={disabled}
        defaultOptions={options}
        cacheOptions
        isMulti={isMulti}
        styles={{
          menu: (provided) => ({
            ...provided,
            zIndex: 999
          })
        }}
        isLoading={loading}
        value={getValues(values)}
        loadOptions={loadingOptions}
        noOptionsMessage={({ inputValue }) =>
          inputValue.length ? "No options" : "Start typing..."
        }
        onChange={handleChange}
      />
    </React.Fragment>
  );
};

AlternativeNamesSelect.propTypes = {
  customers: PropTypes.array,
  actions: PropTypes.object,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  isMulti: PropTypes.bool,
  name: PropTypes.string,
  values: PropTypes.array,
  disabled: PropTypes.bool,
  setValues: PropTypes.func,
  getValues: PropTypes.func,
  onChange: PropTypes.func
};

function mapStatesToProps(state) {
  return {
    customers: state.reducers.customers
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...customerActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(AlternativeNamesSelect);
